export const TRANSLATIONS_ES = {
  menu: {
    about: "Nuestra historia",
    services: "¿Qué hacemos?",
    ecosystem: "Aldealista Life",
    awards: "Premios",
    media: "Prensa",
    app: "La App",
    contact: "Contacto",
    language: "Idioma",
  },
  about: {
    bannerTitle: "Aldealista: hacemos visible lo invisible",
    bannerSubtitle:
      "Si no es un buen lugar para vivir no es un buen lugar para visitar",
    /*
    bannerSubtitle:
      "Rural Match contra la despoblación: conectando el presente con el futuro del campo",
    */
    bannerFeatures1: "Conectamos a las personas con los pueblos",
    bannerFeaturesSub1:
      "Facilitamos la integración de nuevos residentes en comunidades rurales, brindando oportunidades para vivir, trabajar y prosperar.",
    bannerFeatures2: "Somos el movimiento del Renacimiento Rural",
    bannerFeaturesSub2:
      "Revitalizamos las áreas rurales, promoviendo un desarrollo sostenible que atrae a personas, empresas y talento hacia un futuro próspero en el campo.",
    bannerFeatures3: "Porque los pueblos no pueden desaparecer",
    bannerFeaturesSub3:
      "Cada pueblo cuenta una historia. Luchamos para que esa historia siga viva, impulsando soluciones que aseguren su supervivencia y crecimiento.",
    mainTitle: "Nuestra historia",
    mainSubtitle: "Nacimos de un deseo, de un sueño, de un encargo.",
    header1: "Haz algo para salvar estos pueblos",
    text1:
      "Estas fueron las palabras que su abuela, con 102 años de sabiduría, le dijo antes de partir. Era plena pandemia, y Juan Carlos Pérez, entonces residente en Noruega, decidió regresar a su aldea en Galicia para fundar Aldealista. No fue una decisión cualquiera, fue un llamado: salvar lo rural, revitalizar lo que parecía condenado al olvido.",
    text2:
      "Aldealista no es solo una plataforma; es el motor que impulsa el renacer del ecosistema rural. Conectamos las potencialidades de cada territorio, dando valor a sus recursos y atrayendo a personas de todas partes del mundo. Nuestro objetivo: que la gente elija quedarse, trabajar y vivir en estos lugares que aún tienen tanto que ofrecer.",
    text3:
      "Innovación, creatividad y un impacto real son el corazón de nuestras propuestas. Porque creemos que el futuro también se construye desde lo rural.",
    text4:
      "Hoy, Aldealista está presente en 52 países, uniendo a personas y comunidades. Estamos creando un nuevo futuro rural, lleno de oportunidades y vida.",
    ourTeam: "Nuestro equipo",
    ourTeamSubtitle: "Impulsores del Renacimiento Rural",
    team1: "Juan Carlos Pérez",
    team1Sub:
      "CEO - Socio fundador Grupo Rural Manager SL y VPF Scandinavia AS - Desarrollo IT",
    team2: "Juan Martín",
    team2Sub: "Socio fundador Grupo Rural Manager SL - Controller Aceleradora",
    team3: "María Valcarcel",
    team3Sub: "Marca",
    team4: "Migue Gil",
    team4Sub: "Plataforma Booking - Suscripción",
    team5: "Rocío Pérez",
    team5Sub: "Marketing Digital",
    team6: "Isabel Sánchez Tejado",
    team6Sub: "Escuela de Turismo Generativo",
    team7: "Rita Gasalla",
    team7Sub: "Arquitectura Saludable",
    team8: "Raquel García",
    team8Sub: "Arquitectura Saludable",
    team9: "Yanina Chiora",
    team9Sub: "Estrategia Digital y Comunidad",
  },
  services: {
    mainTitle: "¿Qué hacemos?",
    mainSubtitle:
      "Luchamos contra la despoblación: nuestro compromiso con el mundo rural",
    title1: "Los pueblos invisibles: una realidad que no podemos ignorar",
    text1:
      "En España, de los 8.131 municipios, 6.827 cuentan con menos de 5.000 habitantes. Son pueblos invisibles, pero esenciales.",
    text2:
      "¿Sabías que el 16% de la población rural alimenta al otro 84% que vive en las ciudades? Esta es la paradoja de un mundo que depende del campo, pero lo deja atrás.",
    text3:
      "En los municipios de menos de 5.000 habitantes, un preocupante 44% de las viviendas están vacías o solo se utilizan como segundas residencias. El campo se vacía mientras la ciudad crece.",
    text4:
      "Más del 80% de la población vive en menos del 20% del territorio. Este desequilibrio nos invita a repensar el futuro de nuestras tierras rurales.",
    text5: "No podemos esperar más.",
    text6: "Es el momento de impulsar el rural.",
  },
  ecosystem: {
    headerTitle: "Aldealista Life",
    headerSubtitle: "La clave para el renacimiento rural",
    text1:
      "Aldealista Life es más que una plataforma. Es una iniciativa completa que conecta soluciones innovadoras con las necesidades del mundo rural. A través de servicios interconectados y estrategias efectivas, estamos abordando tanto los desafíos como las oportunidades que existen en estas comunidades.",
    text2:
      "Nuestro objetivo no es solo atraer nuevos residentes y turistas a las áreas rurales, sino transformar estas regiones con un enfoque integral. Promovemos el desarrollo económico, impulsamos la creación de empleo, y trabajamos en mejorar infraestructuras y servicios esenciales para construir un futuro rural vibrante.",
    subHeader: "¿Qué buscamos lograr?",
    subHeaderText1:
      "Fortalecer la economía rural, impulsando nuevas oportunidades.",
    subHeaderText2:
      "Mejorar la calidad de vida de quienes eligen vivir y trabajar en estas áreas.",
    subHeaderText3:
      "Fomentar un desarrollo sostenible y equilibrado que beneficie tanto a las personas como al medio ambiente.",
    text3:
      "Con estos cinco pilares, Aldealista Life es la plataforma que conecta, descubre y hace crecer a las comunidades rurales, llevando progreso donde más se necesita.",
    item1: "Baldosa QR",
    item2: "Rural Bar Box",
    item3: "Suscríbete a un pueblo",
    item4: "Palleiras Valley",
    item5: "Ruralhaus",
  },
  media: {
    mainHeader: "Prensa",
    subheaderTitle:
      "El impacto mediático desde el 2023: una huella significativa",
    subheaderTitleText:
      "Desde el año 2023, el valor estimado del impacto mediático de Aldealista Life ha alcanzado cifras sorprendentes: más de 1.250.920 € en medios impresos y digitales, y 306.603 € en Radio y Televisión. Estas cifras subrayan el alcance y la relevancia de nuestra misión en la revitalización del mundo rural.",
    subheaderClipping: "Clipping de prensa",
    subHeaderTextClipping:
      "Selección de noticias con la aparición de Aldealista, tanto en medios nacionales como internacionales, con un enlace directo a la fuente original en su idioma.",
    readMore: "Leer más",
  },
  awards: {
    mainHeader: "Premios",
    subheaderTitle: "Reconocimientos y logros que fortalecen nuestra misión",
    subheaderTitle2:
      "¡Una empresa gallega de aldea elegida en el TOP 100 de las startups  del 2024!",
    subheaderText1:
      "En la Guía de Inversión por excelencia en España nos han incluido entre las 100 startups más prometedoras del 2024 para los inversores",
    subheaderText2:
      "La Guía incluye una lista de más de 250 business angels y 300 fondos y vehículos inversión españoles especializados en startups y en activo, además de aglutinar el Informe Nacional sobre las empresas tecnológicas e innovadoras de España.",
    subheaderText3:
      "¡Entre las 100 Startups más prometedoras para los inversores figura Aldealista!",
    awardTitle5:
      "Finalistas en la categoría de App en la prestigiosa IV Edición de los European Technology Awards (Julio 2023)",
    awardSubtitle5:
      "Un evento celebrado en el icónico Hotel Ritz de París. Este reconocimiento subraya nuestra dedicación a la excelencia tecnológica y nuestro compromiso con la innovación tecnológica del ámbito rural.",
    awardTitle4:
      "La Agencia Gallega de Innovación (GAIN) nos ha destacado entre su selección de casos de éxito más innovadores  (noviembre 2023)",
    awardSubtitle4:
      "Este reconocimiento refuerza nuestra posición como líderes en el sector y valida nuestros esfuerzos por impulsar el progreso a través de la innovación y la dinamización del rural gallego.",
    awardTitle3:
      "Ganadores del prestigioso programa “Que Vivan los Pueblos” (noviembre 2023)",
    awardSubtitle3:
      "Una iniciativa respaldada por Yoigo y Unlimited, que busca apoyar a startups comprometidas con el desarrollo rural. Este galardón refleja nuestro compromiso con la revitalización de las comunidades rurales y la creación de soluciones sostenibles para el crecimiento local.",
    awardTitle2: "Mejor Empresa Innovadora 2023 (diciembre 2023)",
    awardSubtitle2:
      "La Confederación de Empresarios de Ourense nos ha otorgado este importante reconocimiento, destacando nuestro enfoque pionero y nuestra capacidad para generar cambios a través de la innovación empresarial. Este premio es un testimonio de nuestro liderazgo en el sector y nuestra visión de futuro.",
    awardTitle1:
      "MadBlue Impact Summit: Ganadores en la categoría People & Social Impact (mayo 2024)",
    awardSubtitle1:
      "Este galardón reafirma nuestro firme compromiso con el impacto social positivo, y nos posiciona como una empresa que pone a las personas y al bienestar social en el centro de sus actividades.",
    readMore: "Leer más",
  },
  app: {
    headerTitle: "La App",
    headerSubtitle: "Descubre tu pueblo",
    text1:
      "Aldealista es la aplicación de la España Rural Viva, que llega para empoderar y convertirse en La Resistencia del Rural. ¡Desliza y descubre tu pueblo!",
    featuresTitle: "¿Cómo funciona?",
    featuresSubtitle: "Domina en tres sencillos pasos la dinámica de la app:",
    featuresText1: "Selecciona tu área",
    featuresSubtext1:
      "Dinos que punto concreto de la geografía quieres explorar, o selecciona todo el territorio si estás indeciso",
    featuresText2: "Desliza",
    featuresSubtext2:
      "Desliza a izquierda o derecha como en las aplicaciones de citas que dices que nunca has utilizado, nuestro algoritmo inteligente aprenderá de tus preferencias",
    featuresText3: "Match",
    featuresSubtext3:
      "¡Creemos que hemos encontrado un pueblo perfecto para ti! Echa un vistazo a su perfil, descubre lo que tiene para ofrecer y prepárate para visitarlo",
    screenshotTitle: "Psst, echa un ojo a la app",
    screenshotSubtitle:
      "Traemos unas capturas a modo de sneak peek para que te vayas familiarizando con Aldealista.",
    metrics: "Métricas",
    metricsSubtitle: "Nuestro impacto en números, desde enero de 2023",
    users: "Usuarios",
    matches: "Matches",
    swipes: "Swipes",
  },
  contact: {
    header: "Contacto",
    headerSubtitle:
      "Estamos creando un futuro rural lleno de oportunidades, y queremos que formes parte de él. ¡Conéctate con nosotros y descubre cómo puedes vivir o trabajar en los pueblos que necesitan tu energía!",
    text1:
      "¿Te gustaría vivir en el rural? Estamos ayudando a personas como tú a encontrar su hogar ideal en áreas rurales que necesitan nuevos residentes.",
    text2:
      "El Renacimiento Rural también es una oportunidad laboral. Existen muchas formas en que tu talento puede contribuir al desarrollo y crecimiento de los pueblos.",
    text3:
      "Estamos aquí para ayudarte, ya sea que tengas consultas, estés buscando un nuevo hogar en un pueblo, o quieras formar parte de una comunidad en crecimiento. ¡Contáctanos hoy!",
    name: "Nombre",
    email: "Correo electrónico",
    topic: "Asunto",
    message: "Mensaje",
    send: "Enviar",
    metrics: "Más de 5000 solicitudes recibidas para repoblar el rural",
  },
  cta: {
    text1: "Aldealista es una marca registrada de Grupo Rural Manager SL",
    text2: "Descubre más sobre nosotros en www.gruporuralmanager.com",
  },
  errors: {
    errorEmpty:
      "Comprueba tus datos: nombre, email, asunto y mensaje son obligatorios.",
    errorGeneric: "Algo fue mal, inténtalo más tarde",
    errorEmail: "El formato del correo es incorrecto",
    sent: "Formulario enviado correctamente",
  },
  footer: {
    partners: "Nuestro colaboradores",
    org: "Organismos",
    companies: "Empresas",
    foundations: "Fundaciones",
    main: "Tanto si eres una persona joven y activa, madurita e interesante, o vives enfadado con el mundo, tenemos un perfil en tu red social favorita. También puedes contactarnos a nuestro correo electrónico: ",
    copyright: "Todos los derechos reservados",
    available: "Disponible en: ",
  },
  month: {
    dec: "Dic",
    jan: "Ene",
    feb: "Feb",
    mar: "Mar",
    apr: "Abr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
  },
};
